import { ApiClientStatus } from 'hellospa/redux/types';

type Result =
  | { apiStatus: ApiClientStatus.Fetch }
  | { apiStatus: ApiClientStatus.Error, message: string }
  | { apiStatus: ApiClientStatus.Success, pages: number, recipient: string }

export type MoarNamespaceState = {
  result: null | Result,
  recipient: string,
  hasErrored: boolean,
  tier: number,
  pages: number,
  resetKey: number,
}

export enum Actions {
  Reset = 'moar/Reset',
  Recipient = 'moar/Recipient',
  GrantFetch = 'moar/GrantFetch',
  GrantSuccess = 'moar/GrantSuccess',
  GrantError = 'moar/GrantError',
  Increment = 'moar/Increment',
  Decrement = 'moar/Decrement',
}

export interface Reset {
  type: Actions.Reset
  payload: {
    resetAll: boolean,
  }
}

export interface Recipient {
  type: Actions.Recipient
  payload: string
}

export interface GrantFetch {
  type: Actions.GrantFetch
}
export interface GrantSuccess {
  type: Actions.GrantSuccess
  payload: {
    pages: number,
    recipient: string
  }
}

export interface GrantError {
  type: Actions.GrantError,
  error: string,
}

export interface Increment {
  type: Actions.Increment
}

export interface Decrement {
  type: Actions.Decrement
}

export type MoarAction =
  | Reset
  | GrantFetch
  | GrantSuccess
  | GrantError
  | Recipient
  | Increment
  | Decrement
